import {
    useSelector as useReduxSelector,
    TypedUseSelectorHook
} from "react-redux";
import {AppStateType} from "../bll/store";

export const useSelector: TypedUseSelectorHook<AppStateType> = useReduxSelector